module.exports = __webpack_public_path__ + "media/images/product/f_e-7e72024c67c119b12d33a6e0a71186a7.png";